import { SxProps } from '@mui/material';
import { ReactElement } from 'react';
import { EvaluationSourcesType } from '@/service/types';
import { formatDate } from '@/utils/formatDate/formatDate';
import { LinkCell } from './LinkCell';
import { SourceButtonsStack } from './SourceButtonsStack';

export type TableCell = {
  label: string;
  value: (rowData: any) => string | number | JSX.Element | ReactElement | null;
  sx?: SxProps;
};

export const TABLE_CELLS = [
  {
    label: 'Link',
    value: ({ url }: EvaluationSourcesType) => <LinkCell url={url} />,
    sx: {
      width: '30%',
    },
  },
  {
    label: 'Comment',
    value: ({ comment }: EvaluationSourcesType) => comment,
    sx: { width: '30%', overflowWrap: 'break-word' },
  },
  {
    label: 'Date',
    value: ({ lastModified }: EvaluationSourcesType) =>
      formatDate(lastModified),
    sx: { width: '15%' },
  },
  {
    label: 'Shared by',
    value: ({ userName }: EvaluationSourcesType) => userName,
    sx: { width: '15%' },
  },
  {
    label: 'Action',
    value: ({ sourceId }: EvaluationSourcesType) => (
      <SourceButtonsStack sourceId={sourceId} />
    ),
    sx: { width: '10%' },
  },
];

export const generalCellSx = {
  p: 0.5,
  '&:last-child': { textAlign: 'right' },
} as const;
